<div class="sp-width__full sp-row__space">
    <h2 class="sp-orders__header sp-color__primary sp-text__ellipsized">
        {{ 'SHARED.TOOLBAR_UNPAID_LABEL' | translate }}
    </h2>
    <div>
        <button
                (click)="filter.emit()"
                mat-icon-button
                [matTooltip]="'GENERAL.FILTER_CTA' | translate"
                class="sp-icon__button sp-icon__button-accent sp-margin__left">
            <mat-icon class="material-symbols-outlined"> tune </mat-icon>
        </button>

        <button
                (click)="refresh.emit()"
                mat-icon-button
                [matTooltip]="'GENERAL.REFRESH_CTA' | translate"
                class="sp-icon__button sp-icon__button-dark sp-margin__left">
            <mat-icon class="material-symbols-outlined"> refresh </mat-icon>
        </button>
    </div>
</div>
